module.exports = __webpack_public_path__ + "static/media/speed-up.afdb2d67.png";